<template>
  <section id="Benefits">
    <div id="Benefits-selector"></div>
    <b-container>
      <div class="content">
        <div class="title">benefits</div>
        <p>
          Our 20-Game Plan is the perfect way to enjoy the season with friends and family – or to treat yourself! Our
          Fan’s Choice Plan give you maximum flexibility by letting you choose the games you want! Plus, as a 20-Game
          Plan
          Holder, you’ll get access to exclusive benefits reserved for Lone Star Members.
        </p>
        <div class="benefits">
          <div class="benefit" v-for="(benefit, i) in benefits" :key="'benefit' + i">
            <img class="bg" :src="benefit.bg" />
            <div class="text">
              <img class="icon" :src="benefit.icon" />
              <h3>{{ benefit.title }}</h3>
              <div class="hover">
                <p>{{ benefit.description }}</p>
                <small v-if="benefit.note">{{ benefit.note }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img class="player-mobile" src="@/assets/images/benefits/player-mobile.png" />
    </b-container>
    <img class="player" src="@/assets/images/benefits/langford-cutout.png" />
  </section>
</template>

<script>

export default {
  name: "Benefits",
  components: {
  },
  data() {
    return {
      benefits: [

        {
          bg: require("@/assets/images/benefits/bg/opening-day.png"),
          icon: require("@/assets/images/benefits/icons/opening-day.svg"),
          title: "opening day",
          description:
            "Guaranteed opportunity to add on Opening Day tickets.",
        },
        {
          bg: require("@/assets/images/benefits/bg/discounts.png"),
          icon: require("@/assets/images/benefits/icons/discounts.svg"),
          title: "DISCOUNTS",
          description:
            "20% off concessions and 15% off merchandise*",
          note: "*Some restrictions apply"
        },
        {
          bg: require("@/assets/images/benefits/bg/exclusive-experiences.png"),
          icon: require("@/assets/images/benefits/icons/exclusive-experiences.svg"),
          title: "exclusive experiences",
          description:
            "Catch on the field",
        },
        {
          bg: require("@/assets/images/benefits/bg/presales.png"),
          icon: require("@/assets/images/benefits/icons/presales.svg"),
          title: "presales",
          description:
            "Early ticket access to Postseason and events at Globe Life Field",
        },
        {
          bg: require("@/assets/images/benefits/bg/choice.png"),
          icon: require("@/assets/images/benefits/icons/choice.svg"),
          title: "choice",
          description:
            "Customize your plan",
        },
        {
          bg: require("@/assets/images/benefits/bg/dedicated-entry-2.png"),
          icon: require("@/assets/images/benefits/icons/dedicated-entry.svg"),
          title: "dedicated entry",
          description:
            "And early entry (select games)",
        },
        {
          bg: require("@/assets/images/benefits/bg/flexibility.png"),
          icon: require("@/assets/images/benefits/icons/flexibility.svg"),
          title: "flexibility",
          description:
            "Generous exchange policy",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
#Benefits {
  position: relative;
  width: 100%;
  background-image: url("~@/assets/images/benefits/benefits-bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  padding: 176px 0 176px 0;

  @media (max-width: $md) {
    padding: 140px 0 32px;
  }


  .container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    position: relative;
    z-index: 2;

    @media screen and (min-width: 1200px) {
      max-width: 1558px;
      width: 95%;
    }

    @media screen and (max-width: 1000px) {
      align-items: center;
      gap: 55px;
    }

    .content {
      width: 70%;
      max-width: 1030px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 45px;

      @media screen and (max-width: 1000px) {
        width: 100%;
      }
    }

    .player-mobile {
      display: none;

      @media screen and (max-width: 1000px) {
        display: block;
        width: 100%;
        max-width: 262px;
      }
    }
  }


  .title {
    color: var(--STH-Dark-Blue, #1E376D);
    text-align: center;
    font-family: "Druk XCond";
    font-size: 125px;
    font-style: normal;
    font-weight: 950;
    line-height: 100px;
    text-transform: uppercase;

  }


  p {
    color: #000;
    text-align: center;
    font-family: Gotham;
    font-size: 16px;
    font-style: normal;
    font-weight: normal;
    line-height: 24px;
    margin-bottom: 0;
    padding: 0 40px;
    /* 150% */

    @media (max-width: $md) {
      padding: 0;
    }
  }


  .benefits {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: 25px;

    .benefit {
      position: relative;
      width: calc(50% - 12.5px);
      height: 200px;
      border-radius: 4px;
      box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.25);
      overflow: hidden;
      padding: 25px;
      display: flex;
      align-items: flex-end;

      @media (max-width: $md) {
        width: 100%;
      }

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0));
        opacity: 0;
        transition: all 0.3s ease-in;
      }

      .bg {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
        top: 0;
        left: 0;
      }

      .text {
        z-index: 1;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;


        h3 {
          color: #FFF;
          font-family: "Druk Wide";
          font-size: 11px;
          font-style: normal;
          font-weight: 700;
          line-height: 11px;
          letter-spacing: 0.55px;
          text-transform: uppercase;
          margin-bottom: 0;
          text-align: left;
          margin-top: 15px;
        }

        .hover {
          opacity: 0;
          max-height: 0;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          transition: all 0.3s ease-in;

          p {
            color: #FFF;
            font-family: Gotham;
            font-size: 14px;
            font-style: normal;
            font-weight: normal;
            line-height: 22px;
            margin-bottom: 0;
            text-align: left;
            margin-top: 15px;
            padding: 0;
          }

          small {
            color: #FFF;
            font-family: Gotham;
            font-size: 12px;
            font-style: normal;
            font-weight: 325;
            margin-bottom: 0;
            line-height: 18px;
            text-align: left;
            margin-top: 15px;
          }
        }
      }

      &:hover {

        &::after {
          background: linear-gradient(to top,
              #000000,
              rgba(0, 0, 0, 0.45));
          opacity: 1;
        }

        .text {
          .hover {
            opacity: 1;
            max-height: 100px;
          }
        }
      }
    }

    @media (max-width: $md) {
      flex-direction: column;
    }

  }

  .player {
    position: absolute;
    top: 0;
    left: 0;
    width: 544px;
    z-index: 1;

    @media screen and (max-width: 1000px) {
      display: none;
    }
  }
}
</style>
